//Quick View

$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
  $(document).on('click', '.qv-add-to-cart [data-action="increase-quantity"]', function(){
    var qtyField = $(this).siblings('.QuantitySelector__CurrentQuantity');
    qtyField.val(Math.max(parseInt(qtyField.val()) + 1, 1));
  });
  $(document).on('click', '.qv-add-to-cart [data-action="decrease-quantity"]', function(){
    var qtyField = $(this).siblings('.QuantitySelector__CurrentQuantity');
    qtyField.val(Math.max(parseInt(qtyField.val()) - 1, 1));
  });
  
  
  
});

function quickView() {
  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      var title = product.title.replace('<br>',' ');
      var type = product.type;
      var vendor = product.vendor;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      var proId = product.id;
      $('.qv-product-title').html(title);
      $('.qv-product-vendor').text(vendor)
     // $('.qv-product-type').text(type);
      $('.qv-product-description').html(desc);
      $('.qv-product-description').append('<a class="qv-full-details" href="' + url + '">View Full Details</a>');
      $('.view-product').attr('href', url);
     // $('.shopify-product-reviews-badge').attr('data-id', proId);
      $('.qv-content .yotpo.bottomLine').attr('data-product-id', proId).attr('data-name', title).attr('data-url', url).attr('data-description', desc);
      var api = new Yotpo.API(yotpo);
	  api.refreshWidgets();
      var image_embed = '<div><img src="' + images + '"></div>';
           image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
           $('.qv-product-images').append(image_embed);
      $('.qv-product-images').css('opacity', '1');
      console.log(product.variants.length);
      if(product.variants.length <= 1){
      	$('.qv-product-options').hide();
      }
      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = '.option.' + opt.toLowerCase();
        $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + ':</span><select class="option-' + i + ' option ' + opt.toLowerCase() + '"></select></div>');
        $(option.values).each(function (i, value) {
          $('.option.' + opt.toLowerCase()).append('<option value="' + value + '">' + value + '</option>');
        });
      });
      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $('.qv-add-button').prop('disabled', true).val('Sold Out');
          $('.qv-add-to-cart').hide();
          $('.qv-product-price').text('Sold Out').show();
          return true
        } else {
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.qv-product-price').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = '';
      $('#quick-view select').each(function (i) {
        if (selectedOptions == '') {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + ' / ' + $(this).val();
        }
      });
      console.log(selectedOptions);
      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        console.log(product.variants);
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            var v_available = v.available;
            $('.qv-product-price').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);            
            if (v_available) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (!v_available) {
                $('.qv-add-button').prop('disabled', true).val('Sold Out');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
          }
        });
      });
    });
    $.fancybox({
      href: '#quick-view',
      maxWidth: 800,
      maxHeight: 600,
      fitToView: true,
      width: '100%',
      height: '100%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $(this).closest('.qv-add-to-cart').find('.QuantitySelector__CurrentQuantity').val();
          var selectedOptions = '';
          var var_id = '';
          $('#quick-view select').each(function (i) {
            if (selectedOptions == '') {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + ' / ' + $(this).val();
            }
          });
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id
            },null,"json").done(function () {
              $('.qv-add-to-cart-response').removeClass('error').addClass('success').html('<span>' + $('.qv-product-title').text() + ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>');              
               
             $.ajax({
               type: "GET",
               url:"/cart?view=drawer",
               success:function(result){
                 var _drawerHtml = $(result).find('form');
                 $('#sidebar-cart form.Drawer__Content').remove();
                 $('#sidebar-cart').append($(result).find('form'));
                 $('.Header__CartDot').addClass('is-visible');
               }
               
             });
            })
          
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').removeClass('success').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
      },
      'afterShow': function () {
       
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
      }
    });
  });
};

$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
//     $('.qv-product-images').slick('setPosition');
  }
});



